import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  p: 0,
};

export const content: SxStyle = {
  padding: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const itemCard: SxStyle = {
  width: '431px',
  height: '245px',
  overflowY: 'auto',
  p: (p) => p.spacing(0.5, 1),
};

export const itemWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  flexGrow: 'unset',
  height: 'auto',
  gap: (p) => p.spacing(1),
  width: '100%',
};

export const scrollbar: SxStyle = { width: '100%' };

export const noResultFoundWrapper: SxStyle = {
  height: (p) => p.spacing(24),
  width: '100%',
};

export const emptyIconBox: SxStyle = {
  background: (p) => p.palette.grey[50],
  borderRadius: (p) => p.spacing(2),
  padding: (p) => p.spacing(0.75),
  display: 'inline-block',
};

export const emptyIconWrapper: SxStyle = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  outlineWidth: (p) => p.spacing(0.5),
  outlineStyle: 'solid',
  outlineColor: (p) => p.palette.grey[200],
  padding: (p) => p.spacing(1.5),
  borderRadius: (p) => p.spacing(2),
  background: (p) => p.palette.common.white,
};

export const noDataTitleBox: SxStyle = {
  position: 'relative',
  width: (p) => p.spacing(20),
  height: (p) => p.spacing(4),
};

export const noDataTitleBox1: SxStyle = {
  position: 'absolute',
  background: (p) => p.palette.grey[50],
  borderRadius: (p) => p.spacing(5),
  width: (p) => p.spacing(20),
  height: (p) => p.spacing(4),
  top: (p) => p.spacing(2),
};

export const noDataTitleBox2: SxStyle = {
  position: 'absolute',
  background: (p) => p.palette.grey[200],
  borderRadius: (p) => p.spacing(2),
  width: (p) => p.spacing(20),
  height: (p) => p.spacing(4),
  top: (p) => p.spacing(1),
};

export const noDataTitleWrapper: SxStyle = {
  position: 'absolute',
  background: (p) => p.palette.common.white,
  width: (p) => p.spacing(20),
  height: (p) => p.spacing(4),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  borderRadius: (p) => p.spacing(1),
};
